export { default } from './svg/stack-icon.svg';
